import { render, staticRenderFns } from "./tableMenu.vue?vue&type=template&id=38056217&scoped=true&"
import script from "./tableMenu.vue?vue&type=script&lang=js&"
export * from "./tableMenu.vue?vue&type=script&lang=js&"
import style0 from "./tableMenu.vue?vue&type=style&index=0&id=38056217&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38056217",
  null
  
)

export default component.exports